import { hasContent, isObject } from '../../../util/guards';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { IAttachment } from '../reducers/types';
import { getMediaAuthToken } from './getMediaToken';

interface IRequestFile {
  parent_folder_id: 'visitor-uploads';
  hash: string;
  tags: unknown[];
  file_name: string;
  refs: unknown[];
  site_id: string;
  app_id: string;
  height: number;
  original_file_name: string;
  modified_ts: number;
  file_size: number;
  created_ts: number;
  user_id: string;
  icon_url: string;
  file_url: string;
  width: number;
  media_type: 'picture';
  mime_type: string;
}

const createUrl = (path: string) => new URL(path, 'https://static.wixstatic.com').href;

const parseJSONResponse = (response: Response) => {
  if (response.status === 200) {
    return response.json();
  }

  return Promise.reject(response.statusText);
};

const mapAttaches = (i: IRequestFile): IAttachment => ({
  name: i.original_file_name,
  url: createUrl(i.file_url),
  width: i.width,
  height: i.height,
});

const createBody = (file: File, upload_token: string): FormData => {
  const formData = new FormData();

  formData.set('upload_token', upload_token);
  formData.set('media_type', 'picture');
  formData.set('parent_folder_id', 'visitor-uploads');
  formData.set('file', file, file.name);

  return formData;
};

export const uploadImage = (images: File[]): Promise<IAttachment[]> => {
  const apiUrl = 'https://files.wix.com/site/media/files/upload/url?media_type=picture';
  return getMediaAuthToken().then((token) => {
    return Promise.all(
      images.map(() => {
        return fetch(apiUrl, {
          method: 'GET',
          mode: 'cors',
          headers: {
            authorization: `APP ${token}`,
          },
        });
      }),
    )
      .then((responses) => {
        return Promise.all(responses.map(parseJSONResponse));
      })
      .then((tokens) => {
        return Promise.all(
          tokens.map(({ upload_url, upload_token }, index) => {
            return fetch(upload_url, {
              method: 'POST',
              mode: 'cors',
              body: createBody(images[index], upload_token),
            });
          }),
        );
      })
      .then((responses) => {
        return Promise.all(responses.map(parseJSONResponse));
      })
      .then((responses) => {
        return [].concat(...responses).map(mapAttaches);
      })
      .catch((error) => {
        logger.log({
          message: 'fail to attach files',
          error,
          callParams: renderModel.get(),
        });

        throw error;
      });
  });
};

// Deprecated in UI V2
export const isImage = (file: File): boolean => {
  return isObject(file) && hasContent(file.type) && file.type.startsWith('image/');
};
